import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';

import {
  Swiper,
  Navigation,
  Pagination,
  Keyboard
} from 'swiper/js/swiper.esm.js';

export default class TerritoryBlockMap {
  constructor(rootElement) {
    gsap.registerPlugin(ScrollToPlugin);

    this.rootElement = rootElement;
    this.markers = this.rootElement.querySelectorAll('[data-name=marker]');
    this.territories = this.rootElement.querySelectorAll('[data-name=territory]');
    this.territoryModalCloseButtons = this.rootElement.querySelectorAll('.js-territory-block-modal-close');
    this.territoryModals = this.rootElement.querySelectorAll('.js-map-modal');
    this.map = this.rootElement.querySelector('.js-territory-block-map');

    // Swiper setup
    Swiper.use([Navigation, Pagination, Keyboard]);

    // Add event listeners for map markers and buttons(data-name="marker").
    if (this.markers.length > 0) {
      this.markers.forEach(marker => {
        marker.addEventListener('mouseenter', (event) => this.focusMapArea(event, marker.dataset.area));
        marker.addEventListener('mouseleave', (event) => this.unfocusMapArea(event, marker.dataset.area));
        marker.addEventListener('click', (event) => this.toggleAreaModal(marker.dataset.area));
      });
    }

    // Add event listeners to map territories
    if (this.territories.length > 0) {
      this.territories.forEach(territory => {
        territory.addEventListener('click', (event) => this.toggleAreaModal(territory.id));
      });
    }

    // Add event listeners to modal close buttons
    if (this.territoryModalCloseButtons.length > 0) {
      this.territoryModalCloseButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeAllModals());
      });
    }

    // Init swipers for all modals
    if (this.territoryModals.length > 0) {
      this.territoryModals.forEach(territoryModal => {
        this.initSwiper(territoryModal);
      });
    }

    // Add click outside modal event listener
    if (this.territoryModals.length > 0) {
      document.addEventListener('click', e => this.handleClickOutsideModal(e));
    }

  } // End Constructor

  // Create Swiper
  initSwiper(modal) {
    const modalSliderContainer = modal.querySelector('.js-territory-modal-slider');
    const paginationElement = modalSliderContainer.querySelector('.swiper-pagination');
    const nextButton = modalSliderContainer.querySelector('.swiper-button-next');
    const prevButton = modalSliderContainer.querySelector('.swiper-button-prev');

    this.slider = new Swiper(modalSliderContainer, {
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        el: paginationElement,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      loop: true,
    });
  }

  // When map marker/related button is hovered highlight map area
  focusMapArea(event, markerName = null) {
    const mapArea = this.rootElement.querySelector('#' + markerName);
    if (mapArea) {
      mapArea.classList.add('--hovered');
    }
  }

  // Remove highlight when mouse off marker/related button
  unfocusMapArea(event, markerName = null) {
    const mapArea = this.rootElement.querySelector('#' + markerName);
    if (mapArea) {
      mapArea.classList.remove('--hovered');
    }
  }

  // Close all the modals - should only be one - loop for fallback
  closeAllModals() {
    const openModals = this.rootElement.querySelectorAll('.territory-block__modal.--active');
    const openModalsV2 = this.rootElement.querySelectorAll('.territory-block-v2__modal.--active');
    const allModals = [...openModals, ...openModalsV2];

    // Hide any open modals
    if (allModals.length > 0) {
      allModals.forEach(modal => {
        modal.classList.remove('--active');
      })
    }
  }


  // Open the modal!
  openAreaModal(modalArea) {
    this.closeAllModals();

    modalArea.classList.add('--active');
    gsap.to(window, {duration: .5, scrollTo: {y: this.map, offsetY: 145}});
  }

  // Show/hide modals
  toggleAreaModal(modalArea) {
    const territoryModal = this.rootElement.querySelector('#modal-' + modalArea);
    if (territoryModal) {
      if (territoryModal.classList.contains('--active')) {
        territoryModal.classList.remove('--active');
      } else {
        this.openAreaModal(territoryModal);
      }

    }
  }

  // When a click is outside of a modal
  handleClickOutsideModal(e) {
    const isModal = e.target.closest('.territory-block__modal');
    const isModalV2 = e.target.closest('.territory-block-v2__modal');
    const isTerritoryButton = e.target.closest('.territory-block__territory-link');
    const isTerritoryButtonV2 = e.target.closest('.territory-block-v2__territory-link');
    const isMapMarker = e.target.closest('svg.territory-block__map .map-marker');
    const isMapMarkerV2 = e.target.closest('svg.territory-block-v2__map .map-marker');
    const isMapArea = e.target.closest('svg.territory-block__map .map-area');
    const isMapAreaV2 = e.target.closest('svg.territory-block-v2__map .map-area');

    if (isTerritoryButton || isTerritoryButtonV2 || isModal || isModalV2 || isMapMarker || isMapMarkerV2 || isMapArea || isMapAreaV2) {
      // do nothing these items have their own events
    } else {
      this.closeAllModals();
    }
  }
}
